import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "../utils/page-title";

export const Route = createFileRoute("/wizard")({
  head: () =>
    pageHead("Discover Your Design", {
      canonicalPath: "/wizard",
      robots: "noindex, nofollow",
    }),
});
